/**
 * Shared constants for the Project Files feature.
 * Centralised here so the hook, dialog, and service layer all reference the
 * same values without importing from UI components.
 */

/**
 * Maximum number of items requested per paginated call to GET /v1/files.
 */
export const FOLDER_FETCH_PAGE_MAX_SIZE = 100;
